var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "listing-feed u-bottom-margin" },
    [
      _c("transition", { attrs: { name: "fade", mode: "out-in" } }, [
        !_vm.hideTagList && _vm.initialFeedLoaded && _vm.tagsLoaded
          ? _c("div", { staticClass: "o-container" }, [
              _c("div", { staticClass: "mobile-toggle" }, [
                _c(
                  "button",
                  {
                    staticClass: "mobile-toggle__button",
                    class: {
                      "mobile-toggle__button--active": _vm.showFilterAtMobile
                    },
                    on: { click: _vm.toggleMobileFilter }
                  },
                  [
                    _c("span", { staticClass: "sr-only" }, [_vm._v("Open")]),
                    _vm._v(" Filters\n        ")
                  ]
                )
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "listing-feed__filter",
                  class: {
                    "listing-feed__filter--show-at-mobile":
                      _vm.showFilterAtMobile
                  }
                },
                [
                  _c(
                    "div",
                    { staticClass: "listing-feed__filter-left" },
                    [
                      _vm.tags.activityType.length
                        ? _c("select-filter", {
                            attrs: {
                              label: "Activity Type",
                              options: _vm.tags.activityType,
                              icon: {
                                viewBox: "0 0 12 16",
                                width: 26,
                                height: 24,
                                url: "/dist/images/icons.svg#icon-arrow"
                              }
                            },
                            on: { hasChanged: _vm.updateRouterQueries },
                            model: {
                              value: _vm.filter.activityType,
                              callback: function($$v) {
                                _vm.$set(_vm.filter, "activityType", $$v)
                              },
                              expression: "filter.activityType"
                            }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.tags.eventPlace.length
                        ? _c("select-filter", {
                            attrs: {
                              label: "Online & in person",
                              icon: {
                                viewBox: "0 0 12 16",
                                width: 26,
                                height: 24,
                                url: "/dist/images/icons.svg#icon-arrow"
                              },
                              options: _vm.tags.eventPlace
                            },
                            on: { hasChanged: _vm.updateRouterQueries },
                            model: {
                              value: _vm.filter.eventPlace,
                              callback: function($$v) {
                                _vm.$set(_vm.filter, "eventPlace", $$v)
                              },
                              expression: "filter.eventPlace"
                            }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.tags.localArea.length
                        ? _c("select-filter", {
                            attrs: {
                              label: "Local area",
                              icon: {
                                viewBox: "0 0 12 16",
                                width: 26,
                                height: 24,
                                url: "/dist/images/icons.svg#icon-arrow"
                              },
                              options: _vm.tags.localArea
                            },
                            on: { hasChanged: _vm.updateRouterQueries },
                            model: {
                              value: _vm.filter.localArea,
                              callback: function($$v) {
                                _vm.$set(_vm.filter, "localArea", $$v)
                              },
                              expression: "filter.localArea"
                            }
                          })
                        : _vm._e()
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "listing-feed__filter-right" },
                    [
                      _vm.tags.timePeriod.length
                        ? _c("select-filter", {
                            attrs: {
                              label: "Filter by date",
                              options: _vm.tags.timePeriod,
                              icon: {
                                viewBox: "0 0 12 16",
                                width: 26,
                                height: 24,
                                url: "/dist/images/icons.svg#icon-calendar"
                              }
                            },
                            on: { hasChanged: _vm.updateRouterQueries },
                            model: {
                              value: _vm.filter.timePeriod,
                              callback: function($$v) {
                                _vm.$set(_vm.filter, "timePeriod", $$v)
                              },
                              expression: "filter.timePeriod"
                            }
                          })
                        : _vm._e()
                    ],
                    1
                  )
                ]
              )
            ])
          : _vm._e()
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "o-container o-container o-container--half-padding" },
        [
          _c("transition", { attrs: { name: "fade", mode: "out-in" } }, [
            _vm.feedLoaded
              ? _c(
                  "div",
                  { key: "results" },
                  [
                    _c(
                      "transition",
                      { attrs: { name: "fade", mode: "out-in" } },
                      [
                        _vm.set[0].children.length
                          ? _c(
                              "div",
                              { staticClass: "c-article-list" },
                              [
                                _vm._l(_vm.set, function(item, index) {
                                  return _c("event-feed-set", {
                                    key: "set-" + index,
                                    attrs: {
                                      "hide-tags": _vm.hideTags,
                                      "default-selected-tags":
                                        _vm.filter.acitivityType,
                                      data: item.children
                                    }
                                  })
                                }),
                                _vm._v(" "),
                                _vm.isLoadingMoreResults
                                  ? _c(
                                      "div",
                                      { staticClass: "listing-feed__message" },
                                      [
                                        _c("span", { staticClass: "sr-only" }, [
                                          _vm._v("Loading")
                                        ]),
                                        _vm._v(" "),
                                        _c("loader")
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _c("app-paging", {
                                  attrs: {
                                    "current-page": _vm.currentPage,
                                    "total-pages": _vm.totalPages,
                                    "current-visible-items-count":
                                      _vm.currentVisibleArticleItemCount,
                                    "total-items-count": _vm.totalEventItemCount
                                  },
                                  on: { loadMoreClicked: _vm.fetchData }
                                })
                              ],
                              2
                            )
                          : _c("p", { staticClass: "listing-feed__message" }, [
                              _vm._v(
                                "\n            Sorry, no results. Please try adjusting the filters.\n          "
                              )
                            ])
                      ]
                    )
                  ],
                  1
                )
              : _c(
                  "div",
                  { key: "loading", staticClass: "listing-feed__message" },
                  [
                    _c("span", { staticClass: "sr-only" }, [_vm._v("Loading")]),
                    _vm._v(" "),
                    _c("loader")
                  ],
                  1
                )
          ])
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }